import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "../axios/AxiosInstance";
export default function CvPresentationNotifications() {
  const [count, setCount] = useState(0);
  const location = useLocation();
  useEffect(() => {
    const key = `jm-cv-followup-seen:${localStorage.getItem("userId") || ""}`;
    let active = true;
    if (location.pathname === "/candidats-proposes")
      localStorage.setItem(key, new Date().toISOString());
    const load = async () => {
      try {
        const { data } = await axios.get("cv-delivery/presentations");
        const seen = localStorage.getItem(key) || "1970-01-01";
        const total = data.reduce(
          (n, row) =>
            n +
            (row.events || []).filter(
              (e) =>
                e.at > seen && e.authorId !== localStorage.getItem("userId"),
            ).length,
          0,
        );
        if (active) setCount(total);
      } catch {}
    };
    load();
    const timer = setInterval(() => {
      if (!document.hidden) load();
    }, 15000);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [location.pathname]);
  return count ? (
    <Link
      to="/candidats-proposes"
      className="block rounded-lg bg-blue-50 p-3 mb-3 text-blue-900"
      role="status"
    >
      {count} nouveau(x) retour(s) sur les candidats proposés · Consulter le
      suivi
    </Link>
  ) : null;
}
